import { useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { Navigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPermissions, clearPermissions } from '../store/slices/permissionsSlice';

const ProtectedRoute = ({ children }) => {
    const dispatch = useDispatch();
    const { loaded, loading, error } = useSelector((state) => state.permissions);

    const token = localStorage.getItem('token');

    // 1. Validate token
    if (!token) return <Navigate to="/login" replace />;

    try {
        const decoded = jwtDecode(token);
        if (decoded.exp * 1000 < Date.now()) {
            localStorage.removeItem('token');
            return <Navigate to="/login" replace />;
        }
    } catch (e) {
        localStorage.removeItem('token');
        return <Navigate to="/login" replace />;
    }

    // 2. Fetch permissions once per session.
    //    Redux is in-memory — every page refresh clears `loaded`, triggering a fresh DB fetch.
    //    The !loading guard prevents duplicate dispatches when multiple ProtectedRoute
    //    instances mount simultaneously (nested routes).
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
        if (!loaded && !loading && !error) {
            dispatch(fetchPermissions());
        }
    }, [loaded, loading, error, dispatch]);

    // 3. If permissions failed to load, clear the stale token and send to login
    if (error && !loaded) {
        dispatch(clearPermissions());
        localStorage.removeItem('token');
        return <Navigate to="/login" replace />;
    }

    // 4. Hold rendering until permissions are ready
    if (!loaded) return null;

    return children;
};

export default ProtectedRoute;
